
// TODO:BRO-1276: import DModal from '@appsumo/dorado-nuxt';
import CommentReview from './PDPCommentReview.vue';
import LegacyCheckbox from '../../ui/LegacyCheckbox.vue';
import LegacyModal from '../../utilities/LegacyModal.vue';
import { DiscussionType } from '../../../constants/discussions';

const TYPE_COPY = {
  dealcomment: 'question',
  dealreview: 'review',
  reply: 'reply',
};

const TEXT_TREE = {
  dealcomment: {
    header: 'Submit a Question',
    placeholder: 'Enter your question',
    notify: 'Notify me via email when someone replies to this question',
    instructionTitle: 'Please check these guidelines before submitting a question:',
    instructionPoints: [
      'Check the FAQ and pinned comments before you post, your question may have already been answered!',
      'Please don’t use this forum as a platform for requesting deal features or new terms.',
      'If you have an AppSumo support related issue, shoot us an email at ||support@appsumo.com||.',
      'Be respectful of you fellow Sumo-lings and partners – rudeness or harassment will not be tolerated.',
    ],
    submit: 'Submit Question',
  },
  reply: {
    header: 'Add a reply',
    placeholder: 'Enter your response',
    notify: 'Notify me via email for follow-ups',
    instructionTitle: 'Please check these guidelines before submitting a review:',
    instructionPoints: [
      'Check the FAQ and pinned comments before you post, your question may have already been answered!',
      'Please don’t use this forum as a platform for requesting deal features or new terms.',
      'If you have an AppSumo support related issue, shoot us an email at ||support@appsumo.com||.',
      'Be respectful of you fellow Sumo-lings and partners – rudeness or harassment will not be tolerated.',
    ],
    submit: 'Submit',
  },
  dealreview: {
    header: 'Submit a review',
    placeholder: 'Enter your review',
    notify: 'Notify me via email when someones replies to this review',
    instructionTitle: 'Please check these guidelines before submitting your review:',
    instructionPoints: [
      'Please review the product you\'re purchasing, not the terms of the deal.',
      'Add value when leaving a review.',
      'Try the product before reviewing it!',
    ],
    submit: 'Submit review',
  },
};

export default {
  name: 'PDPCommentModal',
  components: {
    CommentReview,
    LegacyCheckbox,
    LegacyModal,
  },
  emits: ['click-close', 'on-submit'],
  props: {
    type: {
      type: String,
      default: 'dealcomment',
    },
    hasReviewed: {
      type: Boolean,
    },
  },
  data() {
    return {
      commentText: '',
      commentTitle: '',
      rating: 5,
      notifyEmail: false,
      isValidComment: true,
      isValidTitle: true,
      isProcessing: false,
    };
  },
  computed: {
    isReview() {
      return this.type === DiscussionType.review;
    },
    typeCopy() {
      return TYPE_COPY[this.type];
    },
  },
  watch: {
    commentText() {
      if (!this.isValidComment && this.commentText && this.commentText.length) {
        this.isValidComment = true;
      }
    },
    commentTitle() {
      if (!this.isValidTitle && this.commentTitle && this.commentTitle.length) {
        this.isValidTitle = true;
      }
    },
  },
  methods: {
    onClickCheckbox(notify) {
      this.notifyEmail = notify;
    },
    handleClickClose() {
      this.$emit('click-close');
    },
    onClickSubmit() {
      // jw: if we are already processing there is no reason to do anything else.
      if (this.isProcessing) {
        return;
      }

      // jl: cannot use ?. syntax here (breaks test case)
      const isValidComment = !!(this.commentText && this.commentText.length);
      const isValidTitle = !!(this.commentTitle && this.commentTitle.length);
      const isReview = this.type === DiscussionType.review;

      // jw: we only need a valid title for reviews.
      if (isValidComment && (!isReview || isValidTitle)) {
        // jw: once the on-submit handler finishes this modal will be closed and this flag will no
        //     longer exist. See PDPDiscussion.onSubmitComment where it calls toggleCreateItemModal
        this.isProcessing = true;

        this.$emit('on-submit', {
          comment: this.commentText,
          notifyEmail: this.notifyEmail,
          rating: isReview ? this.rating : null,
          title: this.commentTitle,
          type: this.type,
        });

        return;
      }

      if (isReview) {
        this.isValidTitle = isValidTitle;
      }

      this.isValidComment = isValidComment;
    },
    textContent(key) {
      return (TEXT_TREE[this.type] && TEXT_TREE[this.type][key]) || '';
    },

    updateRating(rating) {
      this.rating = rating;
    },

    onChangeTitle(title) {
      this.commentTitle = title;
    },
  },
};
